<div class="point-balance-root">

  <div class="points-balance-list">
    
    <div class="list-title">
      Point balance list
    </div>
    <div class="list-subtitle">
      Overall point status
    </div>
    <div *ngFor="let item of pointBalanceList" class="points-balance-item">
      <div class="series-item">
        Series {{item.familyName}}
      </div>
      <div class="vip-item">
        <div class="vip-card">
          <mat-icon>credit_card</mat-icon>
          <div class="vip-card-name">
            {{findBusinessLevelBySeries(item.familyId)}}
          </div>
        </div>
      </div>
      <div class="positive-points-item">
        <div class="positive-points-label">
          Total points
        </div>
        <div class="positive-points-value">
          {{item.totalPoints}}
        </div>
      </div>
      <div class="positive-points-item" *ngIf="!isMobile">
        <div class="positive-points-label">
          Added points this month
        </div>
        <div class="positive-points-value">
          {{item.addedOnThisMonth}}
        </div>
      </div>
      <div class="positive-points-item" *ngIf="!isMobile">
        <div class="positive-points-label">
          Redeemed this month
        </div>
        <div class="positive-points-value">
          {{item.redeemedOnThisMonth}}
        </div>
      </div>
      <div class="negative-points-item" *ngIf="!isMobile">
        <div class="negative-points-label">
          Next point expiring
        </div>
        <div class="expiring-values">
          <div class="negative-points-value">
            {{item.nextPointsExpiring}}
          </div>
          <div class="expiring-date">
            ({{item.nextPointsExpiringDate | date : 'MM-dd-yyyy' : 'UTC' : language}})
          </div>
        </div>
      </div>
      <div class="actions-item">
        <mat-icon (click)="navigateToPointsDetail(item.familyId)">chevron_right</mat-icon>
      </div>
    </div>
  </div>

</div>
